const _excluded = ["children", "hideIcon", "loading", "onClick"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styles from "./QBOButton.module.scss";
import { QboIcon } from "../../components/Integrations/QBO/QboIcon";
import { Spinner } from 'seagull';
export function QBOButton(_ref) {
  let {
      children,
      hideIcon,
      loading,
      onClick
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", {
    className: styles.root,
    onClick: onClick,
    disabled: loading,
    "data-testid": rest['data-testid']
  }, !hideIcon && /*#__PURE__*/React.createElement(QboIcon, null), children, loading && /*#__PURE__*/React.createElement("div", {
    className: styles.loading
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 32
  })));
}